/* ══ KW 3.0 — Product page behaviour ═════════════════════════════
   Gallery thumbnails + lazy demo video. No dependencies.
═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Gallery ───────────────────────────────────────────── */
  function initGallery() {
    var thumbs = document.querySelectorAll('.kw-gal__thumb');
    if (!thumbs.length) return;

    thumbs.forEach(function (t) {
      if (t.dataset.kwBound === 'true') return;
      t.dataset.kwBound = 'true';
      t.addEventListener('click', function () {
        var main = document.getElementById(t.dataset.target);
        if (main && t.dataset.full) main.src = t.dataset.full;
        thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ── Demo video ──────────────────────────────────────────
     Below the fold, preload="metadata" never buffers enough for autoplay
     to fire — which is why the frame stayed black. Force a load and play
     when the module comes near the viewport, and pause when it leaves so
     we are not decoding video the customer cannot see. */
  function initVideo() {
    var videos = document.querySelectorAll('.kw-video video');
    if (!videos.length) return;

    function start(v) {
      if (v.readyState < 2) v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused — harmless */ });
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(start);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          start(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '400px 0px', threshold: 0.01 });

    videos.forEach(function (v) {
      if (v.dataset.kwBound === 'true') return;
      v.dataset.kwBound = 'true';
      io.observe(v);
    });
  }

  function init() { initGallery(); initVideo(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Re-run when the theme editor swaps a section in. */
  document.addEventListener('shopify:section:load', init);
})();
